export class Movie {
  constructor() {}

  movieId: string;
  name: string;
  picture: string;
  detailsPicture: string;
  releaseYear: number;
  rating: string;
  description: string;
  videoUrl: string;
  isPartOfCategory: boolean;
  categoryMovieId: string;
  isPartOfHomeScreenGroup: boolean;
  homeScreenGroupMovieId: string;
  userRating: string;
  ratingsCount: string;
  watchProgress: any;
  watchers: any;
  premiumStatus: any;
  views: any
}



// WEBPACK FOOTER //
// ./src/data/Movie.ts